<div class="container">
  <h2>Energy Credit Support</h2>
  <section>
    <table mat-table [dataSource]="data">
      <ng-container matColumnDef="task">
        <th mat-header-cell *matHeaderCellDef>Task</th>
        <td mat-cell *matCellDef="let element">{{ element.task }}</td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element">
          <button mat-raised-button color="primary" (click)="element.action()">
            {{ element.buttonLabel }}
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </section>
</div>
